import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import Countdown from 'react-countdown';
import ReactMarkdown from 'react-markdown';
import { useWeb3React } from '@web3-react/core';

import styles from '../styles/Shop.module.scss';
import TokenGate from './TokenGate';
import RaffleEntryForm from './RaffleEntryForm';
import ConnectButton from './ConnectButton';
import useRaffles from '../hooks/useRaffles';

const raffleAccount = process.env.NEXT_PUBLIC_RAFFLE_ACCOUNT;

const Raffle = ({ raffleKey }) => {
  const raffle = useRaffles(raffleKey);

  const { active } = useWeb3React();
  const [showCountdown, setShowCountdown] = useState(false);
  const [raffleStarted, setRaffleStarted] = useState(false);
  const [raffleEnded, setRaffleEnded] = useState(false);

  const [raffleStart, setRaffleStart] = useState(new Date(0));
  const [raffleEnd, setRaffleEnd] = useState(new Date());

  useEffect(() => {
    setRaffleStart(new Date(raffle.start_time));
    setRaffleEnd(new Date(raffle.end_time));
  }, [raffle]);

  useEffect(() => {
    setShowCountdown(true); // only render countdown on client
    setRaffleStarted(raffleStart.getTime() < Date.now());
    setRaffleEnded(raffleEnd.getTime() < Date.now());
  }, [raffleStart, raffleEnd]);

  const raffleActive = raffleStarted && !raffleEnded;

  return (
    <>
      <div className="d-flex">
        <div>
          <Link href="/shop">
            <a className="btn btn-light rounded-pill px-4">
              <span className="me-1">&#10094;</span> Back
            </a>
          </Link>
        </div>
        {showCountdown ? (
          <div className="ms-auto">
            <div className="btn btn-light rounded-pill px-4">
              {raffleActive ? (
                <>
                  Ends in{' '}
                  <strong>
                    <Countdown
                      date={raffleEnd}
                      days
                      onComplete={() => setRaffleEnded(true)}
                    />
                  </strong>
                </>
              ) : raffleEnded ? (
                <strong className="text-pink">Raffle ended</strong>
              ) : (
                <>
                  Starting in{' '}
                  <strong>
                    <Countdown
                      date={raffleStart}
                      days
                      onComplete={() => setRaffleStarted(true)}
                    />
                  </strong>
                </>
              )}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
      <article>
        <div className="row">
          <div className="col-12 col-lg-5 py-3">
            <div
              style={{
                borderRadius: '20px',
                overflow: 'hidden',
                display: 'flex',
              }}
            >
              <Image
                src={raffle.image}
                width={1200}
                height={1200}
                alt={raffle.title}
              />
            </div>
          </div>
          <div className="col-12 col-lg-7 py-3">
            <div className={styles.card}>
              <div className="p-4 p-md-5">
                <h1 className="display-3 title">{raffle.title}</h1>
                {raffle.description ? (
                  <ReactMarkdown className="lead fw-normal">
                    {raffle.description}
                  </ReactMarkdown>
                ) : (
                  ''
                )}
                <p className="fs-3 fw-bold">The Rules</p>
                <ol>
                  {raffle.rules.map((s, i) => (
                    <li key={i} className="mb-2 fw-bold">
                      <p className="fw-normal">{s}</p>
                    </li>
                  ))}
                </ol>
              </div>
              <div className="p-4 p-md-5" style={{ backgroundColor: '#eee' }}>
                {raffle.disable_ticket_sales ? (
                  <div>
                    <div className="alert alert-dark text-center lead">
                      {raffleEnded ? (
                        <>This raffle has ended</>
                      ) : (
                        <>
                          You can&apos;t buy tickets for this raffle, see the
                          rules for more details.
                        </>
                      )}
                    </div>
                  </div>
                ) : (
                  <div>
                    {active ? (
                      <TokenGate onlyWrapped={raffle.wrapped}>
                        <RaffleEntryForm
                          raffleKey={raffleKey}
                          raffleAccount={raffleAccount}
                        />
                      </TokenGate>
                    ) : (
                      <div className="py-5 text-center">
                        <ConnectButton />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </article>
    </>
  );
};

export default Raffle;
